
import { defineComponent } from 'vue'
import AppContent from '@/components/layout/AppContent.vue'

export default defineComponent({
  components: { AppContent },
  setup() {
    return { }
  }
})
